import React, { useMemo } from 'react'

export type CallSubjectRaw = {
  id: number
  name: string
  parentId: number
  createdAt: string
  removedAt: string | null
}

export type CallSubject = Omit<CallSubjectRaw, 'createdAt' | 'removedAt'> & {
  createdAt: Date
  removedAt: Date | null
}

type State = {
  subjects: CallSubject[]
}

export const CallSubjectManagerContext = React.createContext<State>({
  subjects: [],
})

type Props = {
  subjects: CallSubjectRaw[]
  children: React.ReactNode
}

const CallSubjectManager: React.FC<Props> = ({
  subjects: subjectsRaw,
  children,
}) => {
  const subjects = useMemo(
    () =>
      subjectsRaw.map(subject => ({
        ...subject,
        createdAt: new Date(subject.createdAt),
        removedAt: subject.removedAt ? new Date(subject.removedAt) : null,
      })),
    []
  )

  return (
    <CallSubjectManagerContext.Provider
      value={{
        subjects,
      }}
    >
      {children}
    </CallSubjectManagerContext.Provider>
  )
}

export default CallSubjectManager
